import { render } from "./OpenPlayerAccount.vue?vue&type=template&id=db32f8f4&scoped=true"
import script from "./OpenPlayerAccount.vue?vue&type=script&lang=js"
export * from "./OpenPlayerAccount.vue?vue&type=script&lang=js"

import "./OpenPlayerAccount.vue?vue&type=style&index=0&id=db32f8f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JavonOnuigbo\\mgs\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db32f8f4"]])

export default __exports__